module.exports = __webpack_public_path__ + "static/media/jdesk.d6075393.png";